<template>
    <b-container fluid>
        <b-row class="justify-content-between flex-center">
            <b-col cols="12" md="6">
                <h3>{{$t('prepaid.title')}}</h3>
            </b-col>
            <b-col cols="12" md="6">
                <b-btn v-b-modal.createGroup variant="primary" class="my-4 float-right"><span class="fa fa-plus mx-2"></span> {{$t('prepaid.button')}}</b-btn>
            </b-col>
        </b-row>

        <hr/>
    <b-container fluid class="p-4">
        <b-row class="w-100 noMargin flex-center">
            <b-col cols="12" md="3" class="eventDash m-2 p-2 text-center shadow-lg" v-for="group in groups" @click="goToEvent(group.id)" v-b-popover.hover.right="$t('hover.msg')">
                <h5> {{ group.name }} </h5>
            </b-col>
        </b-row>
    </b-container>

<!--        <b-row v-if="groups">-->
<!--            <b-col>-->
<!--                <events-table position-->
<!--                              search-key="code"-->
<!--                              :items="groups"-->
<!--                              :fields="groupFields"-->
<!--                              @rowClicked="">-->
<!--                </events-table>-->
<!--            </b-col>-->
<!--        </b-row>-->


        <b-modal centered
                 no-close-on-backdrop
                 id="createGroup"
                 title=""
                 hide-footer>
                 <template v-slot:modal-title>
                    {{$t('prepaid.modal.title')}}
                </template>
            <b-col md="12">
                <b-form @submit.prevent="createGroup()" data-vv-scope="createGroup">
                    <b-row>
                        <b-col cols="12">
                            <b-form-group label-for="groupName">{{$t('prepaid.modal.name')}}
                                <b-form-input :state="validateState('createGroup.groupName')"
                                              :class="{'is-invalid': veeErrors.has('createGroup.groupName')}"
                                              v-model="group.name" v-validate="'required|min:6'" id="groupName" ref="groupName" type="text" size="md" name="groupName"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('createGroup.groupName') }}</span>
                            </b-form-group>
                        </b-col>

                        <b-col cols="6">
                            <b-form-group label-for="date_from">{{$t('prepaid.modal.from')}}
                                <date-picker format="YYYY-MM-DD HH:mm:ss"
                                             name="dateFrom"
                                             v-validate="'required'"
                                             v-model="group.date_from"
                                             :not-before="new Date()"
                                             :not-after="group.date_to"
                                             :lang="$parent[$i18n.locale]"
                                             type="datetime"
                                             :minute-step="10"
                                             :first-day-of-week="1"
                                             class="w-100"
                                             id="date_from">
                                </date-picker>
                                <span class="vvError">{{ veeErrors.first('group.date_from') }}</span>
                            </b-form-group>
                        </b-col>

                        <b-col cols="6">
                            <b-form-group label-for="date_to">{{$t('prepaid.modal.to')}}
                                <date-picker format="YYYY-MM-DD HH:mm:ss"
                                             name="dateFrom"
                                             v-validate="'required'"
                                             v-model="group.date_to"
                                             :not-before="new Date() || group.date_from"
                                             :lang="$parent[$i18n.locale]"
                                             type="datetime"
                                             :minute-step="10"
                                             :first-day-of-week="1"
                                             class="w-100"
                                             id="date_to">
                                </date-picker>
                                <span class="vvError">{{ veeErrors.first('group.date_to') }}</span>
                            </b-form-group>
                        </b-col>

                    </b-row>
                    <b-row>
                        <b-col cols="12" class="text-center">
                            <b-btn type="submit" :disabled="veeErrors.any('createGroup')" variant="primary" class="w-50">{{$t('prepaid.modal.button')}}</b-btn>
                        </b-col>
                    </b-row>
                </b-form>
            </b-col>
        </b-modal>
    </b-container>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'prepaidGroups',
        data() {
            return {
                group: {},
                groups: null,
                printError: ('toast.printError'),
                groupFields: [
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'date_from',
                        label: 'Date from',
                        sortable: true
                    },
                    {
                        key: 'date_to',
                        label: 'Date to',
                        sortable: true
                    },
                ],
            }
        },
        methods: {
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            createGroup(){
                this.$validator.validateAll('createGroup').then((result) => {
                    if (!result) {
                        this.$toasted.global.err({
                            message : this.$t(this.printError)
                        });
                    }else{
                        this.$axios.post('prepaid/createGroup', {
                                params: {
                                    group: this.group,
                                }
                            }
                        ).then(response => {
                            if(response.data.success) {
                                this.group = response.data.data;
                                this.$toasted.global.success({
                                    message : this.$t(response.data.data.msg)
                                });
                            }
                        }).then(()=> {
                                this.$nextTick(() => {
                                    this.veeErrors.clear();
                                    this.$nextTick(() => {
                                        this.$validator.reset();
                                    });
                                });
                            }
                        );
                    }
                });
            },
            getGroups(){
                this.$axios.get('prepaid/groups').then(response => {
                    if (response.status === 200) {
                        this.groups = response.data.data;
                    }
                })
            },
            goToEvent(id) {
                this.$router.push('/prepaid/' + id)
            },
        },
        created() {
            let self = this;
            this.getGroups();
            this.interval = setInterval(function () {
                self.getGroups();
            }, 5000);

        },
        destroyed(){
            clearInterval(this.interval);
        },
    };
</script>
